import axios from "axios";
import moment from "moment";

export const FILTER_INVOICE_URL = "/admin-invoices";

export function getFilteredInvoices(companyId: string, data: any) {
  let startDate = data.startDate ? moment(data.startDate).format("MM/DD/YYYY") : "";
  let endDate = data.endDate ? moment(data.endDate).format("MM/DD/YYYY") : "";

  let searchText = data.searchText;
  let sortAt = data.sortAt;
  let sortBy = data.sortBy;

  return axios.get(
    `${FILTER_INVOICE_URL}/${companyId}?${startDate ? `&startDate=${startDate}` : ""}${endDate ? `&endDate=${endDate}` : ""}${
      data?.page ? `&page=${data.page}` : ""
    }${data?.size ? `&size=${data?.size}` : ""}${sortAt ? `&sortAt=${sortAt}` : "&sortAt=invoiceData.invoiceNumber"}${
      sortBy ? `&sortBy=${sortBy}` : "&sortby=desc"
    }${searchText ? `&searchText=${searchText}` : ""}`,
  );
}

export function getInvoiceLogsById(companyId: string, invoiceId: string, invoiceLogsLimit: number) {
  return axios.get(`/invoice/logs/${companyId}/${invoiceId}?limit=${invoiceLogsLimit ? invoiceLogsLimit : 10}`);
}
